import { AxiosInstance } from "axios";
import { deleteEmptyFields  } from '~/utils/helpers';
import { httpError } from "~/api/common";

export default class PosesApi {
  rootPath: string = "/poses";
  instance: AxiosInstance = {} as AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
    httpError.addSource(this.rootPath, 'title.poses')
  }

  getAll = (limit: number = 10, page: number = 1, query?: Api.GetPOSesQuery ): Promise<Api.PosesResponse> =>
    this.instance.get(this.rootPath, { params: { limit, skip: (page - 1) * limit, ...deleteEmptyFields(query || {}) } });

  deletePoses = (ids: string[]): Promise<Api.Response<{}>> =>
    this.instance.delete(this.rootPath, { params: { ids } })

  getPaymentServices = (posId: string): Promise<Api.GetAll<PaymentServicesApi.PaymentServiceDto>> =>
    this.instance.get(`${this.rootPath}/${posId}/payment-services`);

  getPos = (id: string): Promise<Api.PosResponse> =>
    this.instance.get(`${this.rootPath}/${id}`)

  getSerivices = (posId: string): Promise<Api.ServicesResponse> =>
    this.instance.get(`${this.rootPath}/${posId}/services`);

  createPos = (data: Api.CreatePOS): Promise<Api.GetOne<Api.PosDto>> =>
    this.instance.post(this.rootPath, data)

  updatePos = (id: string, data: Api.UpdatePOS): Promise<Api.GetOne<Api.PosDto>> =>
    this.instance.put(`${this.rootPath}/${id}`, data)

  deletePos = (id: string): Promise<Api.Response<{}>> =>
    this.instance.delete(`${this.rootPath}/${id}`)

  generateCertificate = (): Promise<Api.GetOne<{
    public: string;
    dataUrl: string;
    filename: string;
  }>> => 
    this.instance.get(`${this.rootPath}/certificate/generate`)

  getFilterByPaymentServices = (): Promise<Api.GetOne<PaymentServicesApi.PaymentServiceDto[]>> =>
    this.instance.get(`${this.rootPath}/payment-services/filter`)

  getFilterByServiceCategories = (): Promise<Api.GetOne<ServicesCategoriesApi.ServicesCategoryDto[]>> =>
    this.instance.get(`${this.rootPath}/service-categories/filter`)

  getActiveState = (posIds: string[]): Promise<Api.GetAll<{
    connected: boolean;
    posId: string;
  }>> =>
    this.instance.get(`${this.rootPath}/activity/ids`, { params: { posIds: posIds.join(',') } })
}
